import { httpCreate } from './http';

const http = httpCreate('/srv/sys-role');

export const sysRole = {
	getList(id) {
		return http.get('/list');
	},
	getSlimList(id) {
		return http.get('/list-slim');
	},
	addRole(data) {
		return http.post('', data);
	},
	editRole(id, data) {
		return http.put(`/${id}`, data);
	},
};
